var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChromeReaderMode24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 3.50016L22 3.50164C23.1 3.50173 23.9999 4.4018 23.9998 5.5018L23.9988 18.5018C23.9987 19.6018 23.0986 20.5017 21.9986 20.5016L3.99861 20.5002C2.89861 20.5001 1.99868 19.6 1.99877 18.5L1.99984 5.5C1.99993 4.4 2.9 3.50007 4 3.50016ZM3.99984 5.50016L3.99877 18.5002L11.9988 18.5008L11.9998 5.50082L3.99984 5.50016ZM21.9988 18.5016L13.9988 18.501L13.9998 5.50098L21.9998 5.50164L21.9988 18.5016ZM20.9995 9.00156L14.9995 9.00107L14.9994 10.5011L20.9994 10.5016L20.9995 9.00156ZM14.9993 11.5011L20.9993 11.5016L20.9992 13.0016L14.9992 13.0011L14.9993 11.5011ZM20.9991 14.0016L14.9991 14.0011L14.999 15.5011L20.999 15.5016L20.9991 14.0016Z",
    fill: "#505255"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChromeReaderMode24Px);
export default __webpack_public_path__ + "static/media/chrome_reader_mode_24px.b3079cbd61dd71199c6bfa574f9ef3ca.svg";
export { ForwardRef as ReactComponent };